import { useParams, Link } from 'react-router-dom';
import { getMoviesByCategory, getCategoryName, movieCategories } from '@/mocks/movies';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MovieCard from '@/components/base/MovieCard';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const categoryMovies = slug ? getMoviesByCategory(slug) : [];
  const categoryName = slug ? getCategoryName(slug) : '';
  const currentCategory = movieCategories.find((c) => c.slug === slug);

  return (
    <>
      <Navbar />

      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="bg-background-100 border-b border-background-200/50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto py-3">
            <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <span className="text-foreground-800 font-medium">{categoryName}</span>
            </nav>
          </div>
        </div>

        {/* Category Header */}
        <section className="py-8 md:py-12 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center gap-4 mb-6">
              {currentCategory && (
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${currentCategory.icon} text-2xl text-primary-500`}></i>
                </div>
              )}
              <div>
                <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
                  {categoryName}电影
                </h1>
                <p className="text-sm text-foreground-500 mt-1">
                  共 {categoryMovies.length} 部{categoryName}电影，高清不缓冲流畅在线观看
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="sticky top-16 z-30 bg-background-50 border-b border-background-200/50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide flex-wrap">
              {movieCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-200 ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
                  }`}
                >
                  <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Movies Grid */}
        <section className="py-8 md:py-12 bg-background-50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto">
            {categoryMovies.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
                {categoryMovies.map((movie) => (
                  <MovieCard key={movie.id} movie={movie} size="small" />
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <i className="ri-film-line text-3xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500 text-sm">该分类暂无影片</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: `${categoryName}电影 - 天堂影院`,
            description: `天堂影院${categoryName}电影分类，高清${categoryName}电影在线观看，免费电影网站${categoryName}电影大全。`,
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "首页",
                  item: "https://www.ttcinema.com",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: categoryName,
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}